import { useLocalStorage } from '@karnov/kui-react'
import { useCallback } from 'react'

import { useUserQuery } from 'api/user/queries'
import { localStorageKeys } from 'consts/localStorageKeys'
import { Country } from 'types/Api'

import { useFeatureFlag } from './useFeatureFlag'

type Output = {
  contentCountry: Country | undefined
  onSelectContentCountry: (country: Country | null) => void
}

export const useContentCountry = (): Output => {
  const [storedContentCountry, setStoredContentCountry] = useLocalStorage<Country | null>(
    localStorageKeys.contentCountry,
    null,
  )

  const hasMultiLanguagesFlag = useFeatureFlag('multi_languages')
  const { data: userData } = useUserQuery({
    select: ({ user: { country } }) => ({ country }),
  })

  const handleSelectContentCountry = useCallback(
    (country: Country | null) => {
      setStoredContentCountry(country)
    },
    [setStoredContentCountry],
  )

  // Always return contentCountry - either selected or user's default country
  const contentCountry = hasMultiLanguagesFlag && storedContentCountry && storedContentCountry !== userData?.country
    ? storedContentCountry
    : userData?.country

  return {
    contentCountry,
    onSelectContentCountry: handleSelectContentCountry,
  }
}
